// environment.ts (for development)
export const environment = {
  production: false,

  //dbName: 'a2zerp_prod',
  apiBaseUrl: 'https://app.rsa20.a2zerp.com/v1/api/',
  //apiBaseUrl: 'http://172.20.10.4/v1/api/',
  //apiBaseUrl: 'http://192.168.31.50/v1/api/',
  //apiBaseUrl: 'http://192.168.183.131/v1/api/', 
  dbName: 'test17',//'a1latest',
  //apiBaseUrl: 'http://192.168.1.7/v1/api/'
};
